import styled from "@emotion/styled";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #f1f2fe;
`;
export default Divider;
